import { PosMultiSelect } from 'src/core/POS/PosMultiSelect';

import {
  PurchaseVendorMultiSelectorProps,
  usePurchaseVendorSelector,
} from './usePurchaseVendorSelector';

export function PurchaseVendorMultiSelector({
  disabled,
  additionalOptions,
  additionalOptionsPosition,
  placeholderText,
  ...props
}: PurchaseVendorMultiSelectorProps) {
  const { posSelectProps } = usePurchaseVendorSelector({
    additionalOptions,
    additionalOptionsPosition,
    placeholderText,
  });

  return <PosMultiSelect {...props} disabled={disabled} {...posSelectProps} />;
}
